export default __webpack_public_path__ + "static/media/store.4fa18755.jpeg";